import { render, staticRenderFns } from "./ShorexIntroList.vue?vue&type=template&id=ef5a4fa6&scoped=true"
import script from "./ShorexIntroList.vue?vue&type=script&lang=js"
export * from "./ShorexIntroList.vue?vue&type=script&lang=js"
import style0 from "./ShorexIntroList.vue?vue&type=style&index=0&id=ef5a4fa6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5a4fa6",
  null
  
)

export default component.exports